import { useCallback, useState } from 'react';
import type {
  AnalysisVerificationResult,
  SpectralAnalysisSnapshot,
} from '../types';
import { getVerificationErrorMessage } from './verificationErrors';
import { verifySpectralAnalysis } from './verifySpectralAnalysis';

export const isOpenAiVerificationConfigured = () => true;

export const getOpenAiVerificationErrorMessage = getVerificationErrorMessage;

export const useSpectralVerification = (
  initialVerification: AnalysisVerificationResult
) => {
  const [verification, setVerification] =
    useState<AnalysisVerificationResult>(initialVerification);
  const [isVerifying, setIsVerifying] = useState(false);

  const runVerification = useCallback(
    async (snapshot: SpectralAnalysisSnapshot) => {
      setIsVerifying(true);
      try {
        const result = await verifySpectralAnalysis(snapshot);
        setVerification(result);
        return result;
      } finally {
        setIsVerifying(false);
      }
    },
    []
  );

  return {
    verification,
    isVerifying,
    runVerification,
    isConfigured: isOpenAiVerificationConfigured(),
  };
};
